import FooterCalloutRepository from "../FooterCalloutRepository"

export default class ResourcesFooterCallout extends FooterCalloutRepository {
    static schemaId = "resource_footerCallout"

    constructor() {
        super(ResourcesFooterCallout.schemaId)
    }
}
